import type { LDContext } from 'launchdarkly-js-client-sdk';

type LDContextIdentity = {
  kind: string;
  // Missing keys are retained here so callers can reject incomplete identities.
  key: string | undefined;
  email: string | undefined;
};

const DEFAULT_CONTEXT_KIND = 'user';

const extractLDContextIdentity = (context: LDContext): LDContextIdentity => ({
  kind: 'kind' in context ? context.kind : DEFAULT_CONTEXT_KIND,
  key: typeof context.key === 'string' ? context.key : undefined,
  email: typeof context.email === 'string' ? context.email : undefined,
});

/**
 * Returns true when contexts have the same identity fields used by buildLdContext.
 * Other LaunchDarkly context fields are intentionally ignored.
 */
export const isSameLDContext = (current: LDContext, next: LDContext): boolean => {
  const currentIdentity = extractLDContextIdentity(current);
  const nextIdentity = extractLDContextIdentity(next);

  if (!currentIdentity.key || !nextIdentity.key) {
    return false;
  }

  return (
    currentIdentity.kind === nextIdentity.kind &&
    currentIdentity.key === nextIdentity.key &&
    currentIdentity.email === nextIdentity.email
  );
};
